import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { armInstallPrompt, registerServiceWorker } from "./pro/device";

/* The RocketRep tokens, imported exactly once, here. Every stylesheet below
   this point uses the variables and defines no colour of its own. */
import "./theme.css";
import "./app.css";

/*
 * ★ Armed here, at startup, and not inside the screen that wants it.
 *   Android fires `beforeinstallprompt` ONCE and very early; a listener added
 *   later has already missed it, and the app can then never show its own
 *   install button. iOS fires nothing at all, which is why the Me screen shows
 *   written steps there instead.
 */
armInstallPrompt();

/*
 * ★ The worker is what makes notifications possible at all — on iOS a push can
 *   ONLY be displayed from a service worker, and only in an installed PWA. It
 *   is registered unconditionally and early because registration is cheap, and
 *   because a rep who turns reminders on should not then wait for a worker to
 *   install before the first one can arrive.
 *
 *   Deliberately not awaited: a failed registration (private window, an
 *   insecure origin during LAN testing) must cost notifications and nothing
 *   else. The app still runs.
 */
void registerServiceWorker();

const host = document.getElementById("root");
if (!host) throw new Error("index.html is missing #root");

createRoot(host).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
